import { Box, Typography } from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { useLedgerEnv } from "@/hooks/use-ledger-env";

const SandboxBanner = () => {
  const { isSandbox } = useLedgerEnv();

  if (!isSandbox) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 2,
        py: 1,
        borderRadius: 2,
        backgroundColor: "#fffbeb",
        border: "1px solid #f59e0b",
        color: "#92400e",
      }}
    >
      <WarningAmberOutlinedIcon fontSize="small" />
      <Typography variant="body2" fontWeight={600}>
        SANDBOX / TEST DATA — nothing here is real money. Switch to LIVE for
        production ledgers.
      </Typography>
    </Box>
  );
};

export default SandboxBanner;
